'use strict';
namespace Dashboard {

    export class DashboardBookingsErrorMessage {

        private bookingNotYours : string | null;

        setMessage(bookingId: string): void {
            this.bookingNotYours = bookingId;
        }

        getMessage(): string | null {
            let bookingId = this.bookingNotYours;
            this.bookingNotYours = null;
            return bookingId;
        }

    }

    angular
        .module('dashboard')
        .service('dashboardBookingsErrorMessage', DashboardBookingsErrorMessage);

}
